import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, vModelText as _vModelText, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  class: "modal fade",
  id: "changePasswordModal",
  module: "dialog"
}
const _hoisted_2 = { class: "modal-dialog modal-md" }
const _hoisted_3 = { class: "modal-content" }
const _hoisted_4 = { class: "modal-header" }
const _hoisted_5 = { class: "modal-title" }
const _hoisted_6 = { class: "modal-body" }
const _hoisted_7 = { class: "row" }
const _hoisted_8 = { class: "col" }
const _hoisted_9 = { class: "form-group" }
const _hoisted_10 = { class: "form-label" }
const _hoisted_11 = { class: "row" }
const _hoisted_12 = { class: "col" }
const _hoisted_13 = { class: "form-group" }
const _hoisted_14 = { class: "form-label" }
const _hoisted_15 = { class: "row" }
const _hoisted_16 = { class: "col" }
const _hoisted_17 = { class: "form-group" }
const _hoisted_18 = { class: "form-label" }
const _hoisted_19 = { class: "modal-footer" }
const _hoisted_20 = {
  type: "submit",
  class: "btn btn-sm btn-outline-info-reverse"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("h4", _hoisted_5, _toDisplayString(_ctx.$t('changePassword')), 1),
          _createElementVNode("button", {
            type: "button",
            class: "close",
            "data-bs-dismiss": "modal",
            "aria-label": "Close",
            onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.close()))
          }, [...(_cache[6] || (_cache[6] = [
            _createElementVNode("span", { "aria-hidden": "true" }, "×", -1)
          ]))])
        ]),
        _createElementVNode("form", {
          onSubmit: _cache[5] || (_cache[5] = 
//@ts-ignore
(...args) => (_ctx.onChangePassword && _ctx.onChangePassword(...args)))
        }, [
          _createElementVNode("div", _hoisted_6, [
            _createElementVNode("div", _hoisted_7, [
              _createElementVNode("div", _hoisted_8, [
                _createElementVNode("div", _hoisted_9, [
                  _createElementVNode("label", _hoisted_10, [
                    _createTextVNode(_toDisplayString(_ctx.$t('oldPassword')) + " ", 1),
                    _cache[7] || (_cache[7] = _createElementVNode("span", { class: "text-danger" }, "*", -1))
                  ]),
                  _withDirectives(_createElementVNode("input", {
                    type: "password",
                    class: "form-control input-sm",
                    "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.form.oldPassword) = $event)),
                    required: ""
                  }, null, 512), [
                    [_vModelText, _ctx.form.oldPassword]
                  ])
                ])
              ])
            ]),
            _createElementVNode("div", _hoisted_11, [
              _createElementVNode("div", _hoisted_12, [
                _createElementVNode("div", _hoisted_13, [
                  _createElementVNode("label", _hoisted_14, [
                    _createTextVNode(_toDisplayString(_ctx.$t('newPassword')) + " ", 1),
                    _cache[8] || (_cache[8] = _createElementVNode("span", { class: "text-danger" }, "*", -1))
                  ]),
                  _withDirectives(_createElementVNode("input", {
                    type: "password",
                    class: "form-control input-sm",
                    "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.form.newPassword) = $event)),
                    required: ""
                  }, null, 512), [
                    [_vModelText, _ctx.form.newPassword]
                  ])
                ])
              ])
            ]),
            _createElementVNode("div", _hoisted_15, [
              _createElementVNode("div", _hoisted_16, [
                _createElementVNode("div", _hoisted_17, [
                  _createElementVNode("label", _hoisted_18, [
                    _createTextVNode(_toDisplayString(_ctx.$t('confirmPassword')) + " ", 1),
                    _cache[9] || (_cache[9] = _createElementVNode("span", { class: "text-danger" }, "*", -1))
                  ]),
                  _withDirectives(_createElementVNode("input", {
                    type: "password",
                    class: "form-control input-sm",
                    "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.form.confirmPassword) = $event)),
                    required: ""
                  }, null, 512), [
                    [_vModelText, _ctx.form.confirmPassword]
                  ])
                ])
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_19, [
            _createElementVNode("button", {
              type: "button",
              class: "btn btn-sm btn-outline-close",
              onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.close()))
            }, [
              _cache[10] || (_cache[10] = _createElementVNode("i", { class: "fas fa-times me-1" }, null, -1)),
              _createTextVNode(_toDisplayString(_ctx.$t('close')), 1)
            ]),
            _createElementVNode("button", _hoisted_20, [
              _cache[11] || (_cache[11] = _createElementVNode("i", { class: "fas fa-save me-1" }, null, -1)),
              _createTextVNode(_toDisplayString(_ctx.$t('change')), 1)
            ])
          ])
        ], 32)
      ])
    ])
  ]))
}